export default __webpack_public_path__ + "static/avatar_feedback1-4d4ee6ff4b8b7ef7502a2247e7812e72.webp";